import { Store } from "@tanstack/store";
import type {
	AlertDataMap,
	TAlertKeys,
} from "@/components/common/alerts/alert-provider";

interface AlertState {
	isOpen: boolean;
	alertKey: TAlertKeys | null;
	data: AlertDataMap[TAlertKeys] | Record<string, unknown>;
}

const initialState: AlertState = {
	isOpen: false,
	alertKey: null,
	data: {},
};

export const alertStore = new Store<AlertState>(initialState);

export function openAlert<TKey extends TAlertKeys>(
	key: TKey,
	data: AlertDataMap[TKey],
): void {
	alertStore.setState(() => ({
		isOpen: true,
		alertKey: key,
		data: data,
	}));
}

export function closeAlert(): void {
	alertStore.setState(() => initialState);
}

export function getAlertState(): AlertState {
	return alertStore.state;
}
